import { FC } from 'react';
import styles from './Alert.module.scss';
const Alert: FC<{ text: string }> = ({ text }) => {
  return (
    <div className={styles.Alert}>
      <div className={styles.holder}>
        <img src="/icons/warning.svg" alt="warning" />
        <p>{text}</p>
      </div>
    </div>
  );
};

export default Alert;
